import React, { useState } from 'react';

import Modal from '../../../../components/modules/Modal';
import { ContainedButton, OutlinedButton } from '../../../../components/modules/Buttons';
import { removeCurrentUser } from '../../../../store/user/userSlice';
import { useAppDispatch } from '../../../../store/hooks';
import { removeTooltipShown } from '../../../../helpers';
import styles from './LogOutModal.module.scss';
import { logout } from '../../../../api';

type TLogOutModal = {
  open: boolean;
  switchModal: () => void;
};

const LogOutModal: React.FC<TLogOutModal> = ({ open, switchModal }) => {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const onClose = () => {
    switchModal();
  };
  const onLogout = async () => {
    setLoading(true);
    try {
      await logout();
      dispatch(removeCurrentUser());
      setLoading(false);
      removeTooltipShown();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} loading={loading}>
      <div className={styles.modalBody}>
        <div className={styles.modalHeader}>
          <div className={styles.modalTitle}>Do you want to Log Out?</div>
        </div>
        <div className={styles.uploadBtn1}>
          <ContainedButton disabled={loading} className={styles.btnWidth} onClick={onLogout}>
            Yes
          </ContainedButton>
        </div>
        <div className={styles.uploadBtn2}>
          <OutlinedButton disabled={loading} onClick={onClose}>
            No
          </OutlinedButton>
        </div>
      </div>
    </Modal>
  );
};

export default LogOutModal;
